import { AUTHENTICATION_CHANGE_VIEW_TYPE } from '../../constants/action_types';
import { EEventType } from '../../types/events';
export function changeView(view, data) {
  return function (dispatch, getState, context) {
    var _getState = getState(),
        prevView = _getState.view;

    dispatch({
      type: AUTHENTICATION_CHANGE_VIEW_TYPE,
      view: view,
      data: data
    });
    context.emitter.emit(EEventType.ViewChanged, {
      prevView: prevView.active,
      prevData: prevView.data,
      view: view,
      data: data
    });
  };
}